/*
 * @Description: 三维可视化界面，主要是在球上展示各类型数据
 * @Author: JokerShaw
 * @Date: 2023-06-13 15:05:55
 * @LastEditTime: 2023-07-24 13:50:02
 * @FilePath: \yd_yg_test_project_new\src\components\Pages\ThreeDimensionsVisulization\index.js
 */



import React, { Component } from 'react'
import './index.css'
import Globe from '../../Globe/index'
import GlobeTool from '../../GlobeTool/index'
import Header4 from '../../Header/Header4'
import Iframe from '../Iframe/index'

const googleImgUrl = "/TianDiTu/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=007da76f0d257e291f886de0871f6ea6"


export default class ThreeDimensionsVisulization extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDouble: false
    }
    this.Dearth = null
  }
  componentDidMount() {
    // this.earthCreated()
  }
  earthCreated = () => {
    let _this = this
    return new Promise(resolve => {
      var interGeo = setInterval(function () {
        if (window.Geovis) {
          clearInterval(interGeo)
          resolve('11')
        }
      }, 100)
    }).then(function () {
      try {
        if (_this.Dearth)
          return;
        _this.Dearth = new window.Geovis.GvViewer("otherEarth", {
          scene: {
            sceneModePicker: true
          },
          shouldAnimate: true,
          timeline: true,
          animation: true
        })
        document.getElementsByClassName("cesium-viewer-toolbar")[1].style.display = "none"
        document.getElementsByClassName("cesium-viewer-timelineContainer")[1].style.display = "none"
        document.getElementsByClassName("cesium-viewer-animationContainer")[1].style.display = "none"
        // var script2 = document.createElement("script")
        // script2.src = "./Build/DrawHelper.js"
        // document.querySelector("body").appendChild(script2)
        _this.Dearth.imageryLayers._layers[0].show = false
        _this.Dearth.imageryLayers.addImageryProvider(
          new window.Geovis.UrlTemplateImageryProvider({
            url: googleImgUrl
          })
        )
        _this.Dearth.scene.debugShowFramesPerSecond = true
      } catch (error) {
        console.log(error);
      }
    })
  }
  render() {
    return (
      <>
        <Header4></Header4>
        <Iframe
          url={'https://caplos.aircas.ac.cn/app-earth/build/'}
        ></Iframe >
        {/* <div className="three-dimension-visulization-wrap">
          <div className='three-dimension-visulization-wrap-earth'>
            <div className="three-dimension-visulization-earth-wrap">
              <Globe showFps={true}></Globe>
              <GlobeTool earth={window.earth}></GlobeTool>
            </div>
            <div className="three-dimension-visulization-earth-wrap" style={{ display: this.state.showDouble ? 'block' : 'none' }}>
              <div className='otherErath' id='otherEarth'></div>
              <GlobeTool earth={this.Dearth}></GlobeTool>
            </div>
          </div>
          <div className='showDouble' onClick={() => this.setState({ showDouble: !this.state.showDouble })}>分屏显示：{this.state.showDouble ? '开' : '关'}</div>
        </div> */}
      </>
    )
  }
}
